import React, { Component } from "react";
import { Col, Container, Row, Form } from 'react-bootstrap';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import axios from "axios";
import Select from '../../Components/PCSelect';
import Swal from "sweetalert2";
import PhoneClinicGrid from "../../Components/PhoneClinicGrid";
import RowActions from "../../Components/PhoneClinicGrid/RowActions";
import FormCard from './shared/FormCard';

const ROLE_LIST = [
    // {
    //     id: 1,
    //     value: 1,
    //     label: "Clinic-Admin",
    // },
    {
        id: 2,
        value: 2,
        label: "Manager",
    },
    {
        id: 3,
        value: 3,
        label: "User",
    }
]

const ROLE_FOR_LIST = [
    // {
    //     id: 1,
    //     value: 1,
    //     label: "System",
    // },
    {
        id: 2,
        value: 2,
        label: "Shop",
    },
    {
        id: 3,
        value: 3,
        label: "Warehouse",
    },
    {
        id: 4,
        value: 4,
        label: "Pay Account",
    }
]

class CommonUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {

            UserList: [],
            showForm: false,

            GRP_ATT_LIST: [],

            PC_USR_ID: "",
            PC_USR_NAME: "",
            PC_USR_EMAIL: "",
            PC_USR_PASSWORD: "",
            PC_USR_ADDRESS: "",
            PC_USR_ROLE_ID: "",
            PC_GRP_ID: "",
            PC_GRP_ATT: "",
        };
        this.gridRef = React.createRef(null);
    }

    // componentDidMount() {
    //     let { searchData, totalRecordsPerPage, paginationValue } = this.state
    //     this.getGridData(searchData, totalRecordsPerPage.value, paginationValue)
    // }

    async getGridData(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getData = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/Common/GetCommonUsers.php`, formData);
        let data = getData.data
        let UserList = []

        if (data.success === 1) {
            UserList = data.data
            pagination.totalItems = parseInt(data.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ UserList })
        this.props.toggleLoader(false)
    }

    handleAddDevice() {
        this.setState({
            showForm: true
        })
    }

    async handleChangeInput(fieldName, event) {
        let targetValue
        switch (fieldName) {
            case "PC_USR_ROLE_ID":
            case "PC_GRP_ATT":
                targetValue = event
                break;

            case "PC_GRP_ID":
                switch (event.value) {
                    case 2:
                        await this.getShopList()
                        break;
                    case 3:
                        await this.getWarehouseList()
                        break;
                    case 4:
                        await this.getAllPayaccount()
                        break;
                    default:
                        break;
                }
                targetValue = event
                break;

            default:
                targetValue = event.target.value
                break;
        }
        this.setState({ [fieldName]: targetValue })
    }

    async getShopList(selectedID = "") {
        const getShops = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
        let shopData = getShops.data
        let GRP_ATT_LIST = [], selectedData = ""
        if (shopData.success === 1) {
            for (let i = 0; i < shopData.data.length; i++) {
                const shop = shopData.data[i];
                if (selectedID === shop.PC_SP_ID) {
                    selectedData = {
                        "value": shop.PC_SP_ID,
                        "label": shop.SP_NAME,
                        "type": "shop"
                    }
                }
                GRP_ATT_LIST.push({
                    "value": shop.PC_SP_ID,
                    "label": shop.SP_NAME,
                    "type": "shop"
                })
            }
        }
        this.setState({ GRP_ATT_LIST, PC_GRP_ATT: selectedData })
    }

    async getWarehouseList(selectedID = "") {
        const getWarehouse = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllWarehouse.php`);
        let warehouseData = getWarehouse.data
        let GRP_ATT_LIST = [], selectedData = ""
        if (warehouseData.success === 1) {
            for (let i = 0; i < warehouseData.data.length; i++) {
                const warehouse = warehouseData.data[i];
                if (selectedID === warehouse.WAREHOUSE_ID) {
                    selectedData = {
                        value: warehouse.WAREHOUSE_ID,
                        label: warehouse.WAREHOUSE_NAME,
                        type: "warehouse"
                    }
                }
                GRP_ATT_LIST.push({
                    value: warehouse.WAREHOUSE_ID,
                    label: warehouse.WAREHOUSE_NAME,
                    type: "warehouse"
                })
            }
        }
        this.setState({ GRP_ATT_LIST, PC_GRP_ATT: selectedData })
    }

    async getAllPayaccount(selectedID = "") {
        const getAllPayAccounts = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllPayAccount.php`);
        let deviceData = getAllPayAccounts.data
        let GRP_ATT_LIST = [], selectedData = ""
        if (deviceData.success === 1) {
            for (let i = 0; i < deviceData.data.length; i++) {
                const eachAccount = deviceData.data[i];
                if (selectedID === eachAccount.ACCOUNT_ID) {
                    selectedData = {
                        "label": eachAccount.ACCOUNT_TITLE,
                        "value": eachAccount.ACCOUNT_ID,
                        "type": "account"
                    }
                }
                GRP_ATT_LIST.push({
                    "label": eachAccount.ACCOUNT_TITLE,
                    "value": eachAccount.ACCOUNT_ID,
                    "type": "account"
                })
            }
        }
        this.setState({ GRP_ATT_LIST, PC_GRP_ATT: selectedData })
    }

    handleCancelDevice() {
        this.setState({
            showForm: false,
            PC_USR_ID: "",
            PC_USR_NAME: "",
            PC_USR_EMAIL: "",
            PC_USR_PASSWORD: "",
            PC_USR_ADDRESS: "",
            PC_USR_ROLE_ID: "",
            PC_GRP_ID: "",
            PC_GRP_ATT: "",
        })
    }

    async handleSubmitDevice() {
        this.props.toggleLoader(true)



        let formData = {
            PC_USR_ID: this.state.PC_USR_ID,
            PC_USR_NAME: this.state.PC_USR_NAME,
            PC_USR_EMAIL: this.state.PC_USR_EMAIL,
            PC_USR_PASSWORD: this.state.PC_USR_PASSWORD,
            PC_USR_ADDRESS: this.state.PC_USR_ADDRESS,
            PC_USR_ROLE_ID: this.state.PC_USR_ROLE_ID?.value,
            PC_GRP_ID: this.state.PC_GRP_ID?.value,
            PC_GRP_ATT: this.state.PC_GRP_ATT?.value,
        }

        let getuserResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddUser.php`, formData);

        this.props.toggleLoader(false)
        if (getuserResult.data.status === 200) {
            Swal.fire(
                'Success',
                getuserResult.data.message,
                'success'
            )
            this.handleCancelDevice()
            this.getGridData()
        } else {
            Swal.fire(
                'Error',
                getuserResult.data.message,
                'error'
            )
        }

    }


    handleEdit(indx) {
        let { UserList } = this.state;
        let userData = UserList[indx];
        let role = "", roleFor = ""
        let filterRole = ROLE_LIST.filter(x => x.id === +userData.PC_USR_ROLE_ID)
        let filterRoleFor = ROLE_FOR_LIST.filter(x => x.id === +userData.PC_GRP_ID)
        if (filterRole && filterRole.length > 0) {
            role = filterRole[0]
        }
        if (filterRoleFor && filterRoleFor.length > 0) {
            roleFor = filterRoleFor[0]
        }

        if (userData.PC_GRP_ATT !== "") {
            switch (+userData.PC_GRP_ID) {
                case 2:
                    this.getShopList(userData.PC_GRP_ATT)
                    break;
                case 3:
                    this.getWarehouseList(userData.PC_GRP_ATT)
                    break;
                case 4:
                    this.getAllPayaccount(userData.PC_GRP_ATT)
                    break;
                default:
                    break;
            }
        }

        this.setState({



            PC_USR_ID: userData['PC_USR_ID'],
            PC_USR_NAME: userData['PC_USR_NAME'],
            PC_USR_EMAIL: userData['PC_USR_EMAIL'],
            // Never pre-filled: blank on save keeps the current password.
            PC_USR_PASSWORD: "",
            PC_USR_ADDRESS: userData['PC_USR_ADDRESS'],

            PC_USR_ROLE_ID: role,
            PC_GRP_ID: roleFor,


            showForm: true
        })
    }

    render() {
        return (
            <Container>
                {this.state.showForm === false ?
                    <PhoneClinicGrid
                        title="USER"
                        buttonLabel="Add User"
                        onClickButton={this.handleAddDevice.bind(this)}
                        isEditable={true}
                        ref={this.gridRef}
                        getData={this.getGridData.bind(this)}
                        tableHeadData={[
                            {
                                label: "USER",
                                isHidden: false
                            },
                            {
                                label: "EMAIL",
                                isHidden: false
                            },
                            {
                                label: "ROLE",
                                isHidden: false
                            },
                            {
                                label: "TYPE",
                                isHidden: false
                            },
                            {
                                label: "NAME",
                                isHidden: false
                            },
                        ]}
                    >
                        {this.state.UserList.map((device, idx) => {
                            let role = ""
                            let filterRole = ROLE_LIST.filter(x => x.id === +device.PC_USR_ROLE_ID)
                            if (filterRole && filterRole.length > 0) {
                                role = filterRole[0].label
                            }
                            let roleFor = ""
                            let filterRoleFor = ROLE_FOR_LIST.filter(x => x.id === +device.PC_GRP_ID)
                            if (filterRoleFor && filterRoleFor.length > 0) {
                                roleFor = filterRoleFor[0].label
                            }
                            return (
                                <TableRow
                                    className="table-rows"
                                    key={idx}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell align='left'  >{device.PC_USR_NAME}</TableCell>
                                    <TableCell align='left' style={{ cursor: 'pointer', color: "#416bc7" }}  >{device.PC_USR_EMAIL}</TableCell>
                                    <TableCell align='left' >{role}</TableCell>
                                    <TableCell align='left' >{roleFor}</TableCell>
                                    <TableCell align='left' >{device.USER_FOR}</TableCell>
                                    <TableCell align='center'>
                                        {/* Delete is deliberately not offered here (it was commented out before 2026-10-22):
                                            handleDelete.bind(this, device.PC_USR_ID) */}
                                        <RowActions actions={[
                                            { type: 'edit', onClick: this.handleEdit.bind(this, idx) },
                                        ]} />
                                    </TableCell>
                                </TableRow>
                            )
                        }
                        )}
                    </PhoneClinicGrid>

                    :
                    <>
                        <FormCard title={this.state.PC_USR_ID ? 'Edit User' : 'Add User'} mode={this.state.PC_USR_ID ? 'edit' : 'new'}
                            onCancel={this.handleCancelDevice.bind(this)}
                            onSave={this.handleSubmitDevice.bind(this)} saveLabel="Save">
                        <Row style={{ margin: "5px" }} >
                            <Col md={12} style={{ textAlign: "start" }} >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }}
                                >
                                    <div style={{ whiteSpace: "nowrap", marginRight: "10px" }} ><strong>CREATE</strong> USER</div>
                                    <div style={{ height: "3px", width: "100%", background: "#a32f2f" }} >
                                    </div>
                                </div>
                            </Col>
                        </Row>


                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        name={"PC_USR_NAME"}
                                       
                                        onChange={this.handleChangeInput.bind(this, "PC_USR_NAME")}
                                        value={this.state.PC_USR_NAME}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        name={"PC_USR_EMAIL"}
                                       
                                        autoComplete="new-password"
                                        onChange={this.handleChangeInput.bind(this, "PC_USR_EMAIL")}
                                        value={this.state.PC_USR_EMAIL}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        name={"PC_USR_PASSWORD"}
                                        type="password"
                                        // Editing: blank keeps the current password (PCAddUser.php). New user: required.
                                        placeholder={this.state.PC_USR_ID ? "Leave blank to keep current password" : "Required"}
                                        aria-describedby="pc-usr-password-hint"
                                        autoComplete="new-password"
                                        onChange={this.handleChangeInput.bind(this, "PC_USR_PASSWORD")}
                                        value={this.state.PC_USR_PASSWORD}
                                    />
                                    <Form.Text id="pc-usr-password-hint" muted>
                                        {this.state.PC_USR_ID ? "Leave blank to keep the current password." : "A password is required for a new user."}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} >
                                <Form.Group className="mb-3" >
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control
                                        name={"PC_USR_ADDRESS"}
                                        as={"textarea"}
                                       
                                        onChange={this.handleChangeInput.bind(this, "PC_USR_ADDRESS")}
                                        value={this.state.PC_USR_ADDRESS || ""}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4} >
                                <Form.Group className="mb-3" >
                                    <Form.Label>Role</Form.Label>
                                    <Select menuPortalTarget={document.body}
                                        name={"PC_USR_ROLE_ID"}
                                       
                                        onChange={this.handleChangeInput.bind(this, "PC_USR_ROLE_ID")}
                                        options={ROLE_LIST}
                                        value={this.state.PC_USR_ROLE_ID}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} >
                                <Form.Group className="mb-3" >
                                    <Form.Label>Role For</Form.Label>
                                    <Select menuPortalTarget={document.body}
                                        name={"PC_GRP_ID"}
                                       
                                        onChange={this.handleChangeInput.bind(this, "PC_GRP_ID")}
                                        options={ROLE_FOR_LIST}
                                        value={this.state.PC_GRP_ID}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} >
                                <Form.Group className="mb-3" >
                                    <Form.Label>Role To</Form.Label>
                                    <Select menuPortalTarget={document.body}
                                        name={"PC_GRP_ATT"}
                                       
                                        onChange={this.handleChangeInput.bind(this, "PC_GRP_ATT")}
                                        options={this.state.GRP_ATT_LIST}
                                        value={this.state.PC_GRP_ATT}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        </FormCard>
                    </>
                }
            </Container>
        );
    }
}

export default CommonUsers;